import { IAeroPhotoTourState } from '../../types/aeroPhoto';

const initialState: IAeroPhotoTourState = {
  backgroundImage: null,
};

export function aeroPhotoTourReducer(state: IAeroPhotoTourState = initialState): IAeroPhotoTourState {
  return state;
}
